import getApiClient from '@/shared/api/api-client/getApiClient';
import ApiResultStatus from '@/shared/api/api-result/ApiResultStatus';

export default async function getAuthSecretToken(): Promise<
  | {
      authSecretToken: string;
      status: ApiResultStatus.OK;
    }
  | {
      errorMessage: string;
      status: ApiResultStatus.ERROR;
    }
> {
  const client = getApiClient();

  const response = await client.get('/api/auth/secret');

  if (!response.ok) {
    return {
      errorMessage: await response.errorMessage(),
      status: ApiResultStatus.ERROR,
    };
  }

  const json = await response.json<{
    secret: string;
  }>();

  return {
    authSecretToken: json.secret,
    status: ApiResultStatus.OK,
  };
}
